import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
import MenuEdit from '../edit/index';
export default {
  name: 'MenuList',
  components: {
    MenuEdit: MenuEdit
  },
  data: function data() {
    return {
      isSelect: this.checkauthority('menu_select'),
      isCreate: this.checkauthority('menu_add'),
      isUpdate: this.checkauthority('emnu_update'),
      isDelete: this.checkauthority('menu_delete'),
      menuTyes: [],
      selectForm: {
        title: ''
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false
    };
  },
  methods: {
    sortChange: function sortChange(data) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                menuId: data.menuId,
                sort: data.sort
              };
              _context.n = 1;
              return api.UPDATE_MENU(par);
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initEunmData: function initEunmData() {
      this.getEnumList('menu_type');
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: name
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this.menuTyes = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    checkMenuType: function checkMenuType(value) {
      for (var i = 0; i < this.menuTyes.length; i++) {
        if (value + '' === this.menuTyes[i].keys) {
          return this.menuTyes[i].values;
        }
      }
    },
    switchChange: function switchChange(value) {
      this.updateStats(value);
    },
    checkStatsType: function checkStatsType(data) {
      if (data.stats === 0) {
        return 'success';
      } else {
        return 'danger';
      }
    },
    checkStats: function checkStats(data) {
      if (data.stats === 0) {
        return '正常';
      } else {
        return '已注销';
      }
    },
    btnCheckStats: function btnCheckStats(data) {
      if (data.stats === 0) {
        return '注销';
      } else {
        return '恢复';
      }
    },
    updateStats: function updateStats(data) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                menuId: data.menuId,
                hidden: data.hidden
              };
              _context3.n = 1;
              return api.UPDATE_MENU(par);
            case 1:
              _this2.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this3 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.daleteApi(index, data);
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                menuId: data.menuId
              };
              _context4.n = 1;
              return api.DELETE_MENU(par);
            case 1:
              _this4.initTableData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return api.DELETE_BATCH_MENU(par);
            case 1:
              _this5.$message.success('操作成功');
              _this5.initTableData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this6 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this6.tableSelects.forEach(function (element) {
          par.push(element.menuId);
        });
        _this6.deleteBatchApi(par);
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.selectForm.title = '';
      this.initTableData();
    },
    search: function search() {
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var par, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              par = {};
              _context6.n = 1;
              return api.GET_MENU_LIST(par);
            case 1:
              res = _context6.v;
              _this7.tableData = res.body;
              _this7.pageTotal = res.body.sumDataCount;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initTableData();
    this.initEunmData();
  }
};